import useI18n from '@/shared/hooks/usei18n'
import { Button, IconButton, TableCell, TableRow } from '@/common'
import { TrashIcon } from '@/common/components/icons'
import { Importer } from '@/features/importers/hooks/importers'
import ReactCountryFlag from 'react-country-flag'
import { useNavigate } from 'react-router-dom'

export default function ImporterRow({
  importer,
  onDeleteClick
}: {
  importer: Importer
  onDeleteClick: () => void
}) {
  const { t } = useI18n()
  const navigate = useNavigate()

  return (
    <TableRow key={importer.id}>
      <TableCell>
        <div className="flex items-center gap-1.5">
          <ReactCountryFlag countryCode={importer.country} svg /> <span>{importer.name}</span>
        </div>
      </TableCell>
      <TableCell>
        <p>{importer.identificationNumber}</p>
      </TableCell>
      <TableCell>
        <p>{importer.customId || '-'}</p>
      </TableCell>
      <TableCell>
        <p>{importer.city}</p>
        <p className="text-sm">{t(`common:countriesByIsoAlpha2.${importer.country}`)}</p>
      </TableCell>
      <TableCell align="right">
        <div className="flex items-center gap-2 justify-end">
          <Button variant="txt-default" sizeType="sm" onClick={() => navigate(`./${importer.id}`)}>
            {t('importers:importersPage.importersList.importerTable.actions.viewImporter')}
          </Button>
          <IconButton
            icon={<TrashIcon />}
            variant="txt-danger"
            sizeType="sm"
            onClick={onDeleteClick}
          />
        </div>
      </TableCell>
    </TableRow>
  )
}
